/**
 * Validates trimmed strings to be expected length to avoid empty strings to be saved, when this not desired
 * @param input Input string to be validated
 * @param length Optional min length of valid string. if not defined, must be at least 1 chars long
 * @return {boolean}
 */
export const isValidLengthString = (input, length = 1) => {
  if (input === undefined) return false;
  if (length < 0) return false;
  return input.trim().length >= length;
};
